// @ts-nocheck
import React, { FunctionComponent } from 'react';
import { FieldProps, getIn } from 'formik';

// MUI
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

// Properties
import * as styles from './FormCheckbox.styles';

type TFormCheckboxProps = {
    handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isCheckboxGroup?: boolean;
}

const FormCheckbox: FunctionComponent<FieldProps & FormControlLabelProps & CheckboxProps & TFormCheckboxProps> = props => {
    const {
        handleChange,
        isCheckboxGroup,
        label,
        disabled,
        checked,
        error,
        helperText,
        field,
        form,
        ...rest
    } = props;

    const isTouched = getIn(form.touched, field.name);
    const errorMessage = getIn(form.errors, field.name);

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (handleChange) {
            handleChange(event);
        }
    }

    return (
        <FormControl
            error={!isCheckboxGroup && (error ?? Boolean(isTouched && errorMessage))}
            onChange={handleCheckboxChange}
        >
            <FormControlLabel
                sx={styles.label}
                label={label}
                control={
                    <Checkbox
                        sx={styles.checkbox}
                        disabled={disabled ?? form.isSubmitting}
                        checked={checked}
                        {...rest}
                        {...field}
                    />
                }
            />
            <FormHelperText
                sx={styles.helper}
            >
                {!isCheckboxGroup && (helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined))}
            </FormHelperText>
        </FormControl>
    );
};

export default FormCheckbox;
